var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('qrcode-stream',{staticStyle:{"width":"500px","height":"500px"},on:{"decode":_vm.onDecode}})
}
var staticRenderFns = []

export { render, staticRenderFns }